import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { HapiElementsLoader } from 'modules/ats/components/HapiElementsLoader'
import CollectionsBootstrap from 'modules/ats/lib/CollectionsBootstrap'
import { AtsContextProvider, useAtsContext } from 'modules/ats/lib/atsContext'
import { useAtsEnabled } from 'modules/ats/lib/atsEnabled'
import { useOpenPositionsEnabled } from 'modules/ats/lib/atsEnabled'

const AtsRootPage = () => {
  const { pathname } = useLocation()
  const { navigation } = useNavigation()
  const openPositionsEnabled = useOpenPositionsEnabled()
  const { atsEnabled } = useAtsEnabled()
  const { canUseAts, canManagePurchaseRequests } = useAtsContext()
  const isHiringManager = atsEnabled && canUseAts
  const isAtsPath = pathname === navigation.ats.fullPath()
  const { featureAvailability } = useFeatureAvailability(Features.ats_vonq)
  const hasJobBoardsEnabled = featureAvailability.available

  if (isAtsPath && isHiringManager) {
    return <Navigate replace to={navigation.ats.jobs.fullPath()} />
  }

  if (isAtsPath && !isHiringManager && openPositionsEnabled) {
    return <Navigate replace to={navigation.ats.openPositions.fullPath()} />
  }

  const authorizeFn = () => {
    if (!atsEnabled) {
      return false
    }

    if (openPositionsEnabled && pathname === navigation.ats.openPositions.fullPath()) {
      return true
    }

    if (
      canManagePurchaseRequests &&
      pathname.includes(navigation.ats.purchaseRequests.fullPath())
    ) {
      return true
    }

    return canUseAts
  }

  if (hasJobBoardsEnabled) {
    return (
      <AuthorizeUser authorizeFn={authorizeFn}>
        <HapiElementsLoader>
          <Outlet />
        </HapiElementsLoader>
      </AuthorizeUser>
    )
  }

  return (
    <AuthorizeUser authorizeFn={authorizeFn}>
      <Outlet />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <AtsContextProvider>
        <AtsRootPage />
      </AtsContextProvider>
    </CollectionsBootstrap>
  )
}

export default RootPage
